import apiClient, { APIResponse } from '../client';

export interface UserProgress {
  total_time_spent: string;
  total_sessions: number;
  average_accuracy: number;
  last_session_accuracy: number;
}

interface UserProgressResponse {
  data: UserProgress;
  error: null | string;
  message: string;
  success: boolean;
}

export const userService = {
  // ... existing methods ...

  getUserProgress: async (): Promise<APIResponse<UserProgressResponse>> => {
    return apiClient.get('/api/v1/users/progress');
  },
};